import React from 'react';
import BasicButton from './BasicButton';
import { successButton } from '@styles/app';

const SuccessButton: React.FC<any> = (props): JSX.Element => {
  return <BasicButton {...props} variant={successButton} />;
};

export default SuccessButton;
